import { IOptionsSectionName } from 'my-poppies-b2b-types';
import { FC } from 'react';

import { PricesOptionsSection } from '@/components/PricesOptionsSection';

type ISectionMapping = Record<IOptionsSectionName, FC | null>;

export const optionsMapping: ISectionMapping = {
  PRICES: PricesOptionsSection,
};
